export const RESET_BOOKMARKS = 'bookmarks/RESET_BOOKMARKS';
export const RESET_BOOKMARKS_POSITION = 'bookmarks/RESET_BOOKMARKS_POSITION';
export const SET_BOOKMARKS_LECTURES = 'bookmarks/SET_BOOKMARKS_LECTURES';



// WEBPACK FOOTER //
// ./src/app/bookmark/store/mutation-types.js